import gql from "graphql-tag";

export const createProject = gql`
  mutation createProject(
    $input: CreateProjectInput!) {
    createProject(input: $input) {
      project {
        id
        name
      }
    }
  }
`;

export const createProjectOptions = {
  name: "createProject",
};
